import { render, staticRenderFns } from "./UiChartDonut.vue?vue&type=template&id=c19aa462"
import script from "./UiChartDonut.vue?vue&type=script&lang=js"
export * from "./UiChartDonut.vue?vue&type=script&lang=js"
import style0 from "./UiChartDonut.vue?vue&type=style&index=0&id=c19aa462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports